module.exports = __webpack_public_path__ + "static/media/5.da0b3fc6.png";